<template>
  <div class="home">
    <div>
      
      <loading-state :state="state"></loading-state>

      <div v-if="matches.length">
        <div class="filterable-content wrap-on-mobile reversed">
          <div class="left-part">
            <h2>Cricket Home</h2>
            <div class="group">
              <ul>
                <li class="tag">
                    <div class="">
                      <router-link class="clean" :to="{name:'cricketChatbot'}">Chatbot</router-link>
                    </div>
                </li>
              </ul>
            </div>
            <div
              class="group"
              v-for="(item, i) in seasonsGrouped" :key="i">
              <h5 class="silent">{{item[0] | momentFormat("MMM YYYY")}}</h5>
              <ul>
                <li
                  v-for="season in item[1]"
                  :key="season.key"
                  class="tag">
                  <div class="">
                    <router-link class="clean" :to="{name:'cricketSeason', params:{key:season.key}}">{{season.short_name}}</router-link>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="right-part">
            <section v-if="matches.length">
              <h2>Recent Matches</h2>
              <div class="sub-content">
                <div class="item link" v-for="match in matches" :key="match.key">
                  <cricket-match-mini :match="match"></cricket-match-mini>
                </div>
              </div>
            </section>
          </div>
        </div>
        <div>
            <section v-if="news.length" class="news-section">
              <h2>News</h2>
              <div class="sub-content">
                <div class="item" v-for="(anews, index) in news" :key="index">
                  <div><b><a class="clean" :href="anews.link" target="new">{{anews.title}}</a></b></div>
                  <p v-html="anews.description"></p>
                  <div class="footer">
                    <span><a class="clean" :href="anews.link" target="new">{{anews.updated | relativeShortDateTime}}</a></span> |
                    <span><a class="clean" :href="anews.provider.url" target="new">{{anews.provider.name}}</a></span>
                  </div>
                  <hr>
                </div>
              </div>
            </section>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { homePage } from '@/models/cricket/core'
import { DataState } from '@/state'

export default {
  name: 'home',
  data () {
    return {
      matches: [],
      seasons: [],
      news: [],
      state: DataState.newLoading()
    }
  },
  created () {
    homePage().then((response) => {
      this.matches = response.recentMatches
      this.seasons = response.recentSeasons
      this.seasonsGrouped = this.restractureSeasons(response.recentSeasons)
      this.news = response.news
      this.state.changeToLoaded()
    })
  },
  methods: {
    restractureSeasons(seasons) {
      const newSeasons = seasons.concat([])
      newSeasons.sort((x, y) => {
        if (x.startDate.isAfter(y.startDate)) {
          return 1
        }
        return -1
      })

      let months = []
      let monthMap = {}
      newSeasons.forEach((season) => {
        const monthKey = season.startDate.format("YYYY-MM")
        if(! monthMap[monthKey]) {
          const monthSeasons = []
          const monthDate = season.startDate.clone().date(1)
          monthMap[monthKey] = monthSeasons
          months.push([monthDate, monthSeasons])
        }

        monthMap[monthKey].push(season)
      })
      
      return months
    }
  }
}
</script>
